



































import { Component, Inject, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import {
  IContractProductProvider,
  IContractProductProviderMethods
} from "@/models/providers/contractProduct";
import Context from "@/mixins/context";
import { SelectedPaymentMethod } from "@/models/selectPaymentMethod";
import PaymentProvider from "@/components/app/global/payments/selectPaymentMethod/provider";

@Component({
  components: {
    "select-payment-method": () =>
      import("@/components/app/global/payments/selectPaymentMethod/index.vue")
  }
})
export default class CProdChangePaymentMethodModal extends Mixins(
  PaymentProvider,
  Context
) {
  // Inject
  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: IContractProductProviderMethods;

  public processing = false;

  // Computed
  public get cProdData() {
    return this.$cProdData();
  }

  public get contract() {
    return this.cProdData.contract;
  }

  public get isChanged() {
    return (
      this.$_.get(this.paymentMethod, "data.gateway_id") !==
        this.contract.gateway_id ||
      this.$_.get(this.paymentMethod, "data.payment_details_id") !==
        this.contract.payment_details_id
    );
  }

  public async changePaymentMethod() {
    if (!this.isChanged || !this.hasValidPaymentMethod) {
      return;
    }
    this.processing = true;
    try {
      this.$_.set(
        this.paymentMethod as SelectedPaymentMethod,
        "data.store",
        true
      );
      await this.preparePaymentData(this.contract.client_id);
      await this.$store.dispatch(
        `data/${DataModules.CONTRACTS}/updatePaymentDetails`,
        {
          id: this.contract.id,
          isAdmin: this.isAdmin,
          data: {
            payment_details_id: this.$_.get(
              this.paymentData,
              "payment_details_id"
            )
          }
        }
      );
      this.$emit("payment-method-changed");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.processing = false;
  }
}
